export const paymentModalWIndow = {
  stripeCardField: {
    expiredLabel: 'Expired'
  },
  paymentMethodMissing: {
    noPaymentMethodCharged: 'No payment method charged',
    missingPaymentMethod: 'Missing payment method'
  }
};
